import type { CollectionEntry } from 'astro:content';
import { debounce } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';
import { filterByText } from '../utils';

export function useSearch(entries: CollectionEntry<'learn'>[]) {
  const [filteredEntries, setFilteredEntries] =
    useState<CollectionEntry<'learn'>[]>(entries);
  const [searchText, setSearchText] = useState('');

  const debouncedFilter = useCallback(
    (text: string) => {
      const filter = debounce((searchText: string) => {
        setFilteredEntries(filterByText(entries, searchText));
      }, 300);
      filter(text);
      return filter.cancel;
    },
    [entries],
  );

  useEffect(() => {
    debouncedFilter(searchText);
  }, [debouncedFilter, searchText]);

  return {
    filteredEntries,
    searchText,
    setSearchText,
  };
}
